export const electronicsLevelTwo = [
    {
      name: "Mobiles & Tablets",
      categoryId: "electronics_mobiles_tablets",
      parentCategoryId: "electronics",
      level: 2,
    },
    {
      name: "Mobiles Accessories",
      categoryId: "electronics_mobiles_accessories",
      parentCategoryId: "electronics",
      level: 2,
    },
    {
      name: "Laptops",
      categoryId: "electronics_laptops",
      parentCategoryId: "electronics",
      level: 2,
    },
    {
      name: "Televisions",
      categoryId: "electronics_televisions",
      parentCategoryId: "electronics",
      level: 2,
    },
    {
      name: "Cameras",
      categoryId: "electronics_cameras",
      parentCategoryId: "electronics",
      level: 2,
    },
    {
      name: "Home Appliances",
      categoryId: "electronics_home_appliances",
      parentCategoryId: "electronics",
      level: 2,
    },
  
  ];
  